export default __webpack_public_path__ + "static/media/login-bg-29.9fd9f980.jpg";